"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
require("core-js/modules/es7.array.includes");
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("core-js/modules/es6.number.constructor");
var _vuex = require("vuex");
var _DragDialog = _interopRequireDefault(require("@/components/DragDialog"));
var _blExchangeAppointment = require("@/api/blExchangeAppointment/blExchangeAppointment");
var _utils = require("@/utils");
var _booking = require("@/api/bookSpace/booking");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'BatchReservationXm',
  components: {
    dragDialog: _DragDialog.default
  },
  props: {
    edoCreditId: {
      type: String,
      default: ''
    },
    vvLBlNo: {
      type: String,
      default: ''
    },
    del: {
      type: String,
      default: ''
    },
    paymentStatus: {
      type: Number,
      default: 0
    },
    forespeakStatus: {
      type: Number,
      default: 0
    },
    forespeakBlNo: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    paymentStatusList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    forespeakStatusList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      fileList: [],
      invoiceHistory: JSON.parse(localStorage.getItem('invoiceHistory')) || [],
      form: {
        mail: '',
        doType: 0,
        invoiceTitle: '',
        paymentMethod: '',
        del: ''
      },
      paidTypeList: [{
        value: '0',
        labelEh: 'Cash',
        labelCN: '现金'
      }, {
        value: '1',
        labelEh: 'Transfer',
        labelCN: '转账'
      }, {
        value: '2',
        labelEh: 'CP-CHEQUE',
        labelCN: '公司支票'
      }, {
        value: '3',
        labelEh: 'MG-CHEQUE',
        labelCN: '个人支票'
      }],
      rules: {
        mail: [{
          required: true,
          message: this.$t('blExchangeAppointment.emailNotNull'),
          trigger: 'change'
        }, {
          type: 'email',
          message: this.$t('blExchangeAppointment.invalidEmail'),
          trigger: ['blur', 'change']
        }, {
          pattern: /^[\w-]+(\.[\w-]+)*@[\w-]+(\.[\w-]+)+$/,
          message: this.$t('blExchangeAppointment.invalidEmail'),
          trigger: 'blur'
        }]
      },
      formDisabled: false
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['language'])),
  watch: {
    // 监听forespeakStatus变化并更新禁用状态
    'form.forespeakStatus': {
      immediate: true,
      handler: function handler(val) {
        console.log('forespeakStatus changed:', val);
        this.formDisabled = val === 1;
      }
    }
  },
  mounted: function mounted() {},
  methods: {
    handleCancel: function handleCancel() {
      var _this = this;
      this.loading = (0, _utils.load)();
      (0, _blExchangeAppointment.cancelForespeak)(this.form.edoCreditId).then(function (res) {
        if (res.success) {
          _this.form = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, _this.form), res.data);
          _this.$message({
            message: _this.$t('blExchangeAppointment.cancelReservationSuccess'),
            type: 'success'
          });
          _this.closed();
        } else {
          _this.$message.error(_this.$t('blExchangeAppointment.cancelReservationFail'));
        }
        _this.closed();
      }).catch(function (err) {}).finally(function () {
        _this.loading.close();
      });
    },
    handleSave: function handleSave() {
      var _this2 = this;
      // 如果预约状态已经是1，只验证必要的字段（bankSlip相关字段）
      if (this.form.forespeakStatus === 1) {
        // 检查水单是否已上传
        // if (!this.form.attachment) {
        //   this.$message.warning(this.$t('blExchangeAppointment.bankSlip') + '不能为空');
        //   return;
        // }

        // 直接提交表单，不进行其他验证
        this.loading = (0, _utils.load)();
        this.form.forespeakBlNo = this.forespeakBlNo;
        this.form.del = this.del;
        (0, _blExchangeAppointment.saveForespeak)(this.form).then(function (res) {
          if (res.success) {
            _this2.$message({
              message: _this2.$t('blExchangeAppointment.reservationSuccessful'),
              type: 'success'
            });
            _this2.closed();
          } else {
            _this2.$message.error(_this2.$t('blExchangeAppointment.reservationFailure'));
          }
        }).finally(function () {
          _this2.loading.close();
        });
        return;
      }

      // 正常状态下的表单验证
      this.$refs['form'].validate(function (valid) {
        if (valid) {
          _this2.loading = (0, _utils.load)();
          _this2.form.forespeakBlNo = _this2.forespeakBlNo;
          _this2.form.del = _this2.del;
          (0, _blExchangeAppointment.saveForespeak)(_this2.form).then(function (res) {
            if (res.success) {
              _this2.$message({
                message: _this2.$t('blExchangeAppointment.reservationSuccessful'),
                type: 'success'
              });
              _this2.closed();
            } else {
              _this2.$message.error(_this2.$t('blExchangeAppointment.reservationFailure'));
            }
          }).finally(function () {
            _this2.loading.close();
          });
        }
      });
    },
    opened: function opened() {
      var _this3 = this;
      if (this.edoCreditId) {
        this.loading = (0, _utils.load)();
        (0, _blExchangeAppointment.getForespeakAction)(this.edoCreditId, 'CNXMN').then(function (res) {
          if (res.success) {
            _this3.form = res.data;
            // 加载数据后立即设置表单禁用状态
            _this3.formDisabled = _this3.form.forespeakStatus === 1;
            console.log('加载数据完成，设置表单禁用状态:', _this3.formDisabled);

            // 如果有附件，更新文件列表
            if (_this3.form.attachment && _this3.form.attachmentName) {
              _this3.fileList = [{
                name: _this3.form.attachmentName,
                url: '',
                uid: _this3.form.attachment
              }];
            }
          }
        }).catch(function (error) {
          console.error('获取数据失败:', error);
        }).finally(function () {
          _this3.loading.close();
        });
      } else {
        this.$set(this.form, 'paymentStatus', this.paymentStatus);
        this.$set(this.form, 'forespeakStatus', this.forespeakStatus);
        // 根据初始状态设置表单禁用状态
        this.formDisabled = this.forespeakStatus === 1;
        console.log('新建表单，设置表单禁用状态:', this.formDisabled);
      }
      this.$set(this.form, 'del', this.del);
    },
    closed: function closed() {
      var _this4 = this;
      this.$nextTick(function () {
        _this4.$refs.form.resetFields();
      });
      this.$emit('handleCloseReservationXm');
    },
    uploadFile: function uploadFile(item) {
      var _this5 = this;
      if (item.file.size > 10 * 1024 * 1024) {
        this.$message.warning(this.$t('blExchangeAppointment.fileSize'));
        this.fileList = [];
        return;
      }
      var validTypes = ['application/pdf', 'image/jpeg', 'image/png', 'image/bmp', 'image/tiff'];
      if (!validTypes.includes(item.file.type)) {
        this.$message.warning(this.$t('blExchangeAppointment.fileFormat'));
        this.fileList = [];
        return;
      }
      if (item.file.name.length > 40) {
        this.$message.warning(this.$t('blExchangeAppointment.attachmentFileLength'));
        this.fileList = [];
        return;
      }
      this.loading = (0, _utils.load)();
      var formDatas = new FormData();
      formDatas.append('file', item.file);
      formDatas.append('bucket', 'commerce');
      (0, _booking.setUploadFile)(formDatas).then(function (res) {
        if (res.code) {
          _this5.form.attachment = res.fileId;
          _this5.form.attachmentName = res.fileName;
        } else {
          _this5.$message.warning(res.errorMessages[0]);
        }
      }).finally(function () {
        _this5.loading.close();
      });
    },
    handleRemove: function handleRemove() {
      var _this6 = this;
      (0, _booking.deleteByFileId)(this.form.attachment).then(function (res) {
        if (res == 'success') {
          _this6.form.attachment = '';
          _this6.$message.success(_this6.$t('roleCertificationApplication.deleteMessage'));
        } else {
          _this6.$message.warning(res.errorMessages[0]);
        }
      });
    },
    beforeRemove: function beforeRemove(file) {
      return this.$confirm("\u786E\u5B9A\u79FB\u9664 ".concat(file.name, "\uFF1F"));
    },
    querySearchInvoice: function querySearchInvoice(queryString, cb) {
      var _this7 = this;
      this.restaurants1 = [];
      this.invoiceHistory.map(function (item) {
        _this7.restaurants1.push({
          value: item.invoiceTitle
        });
      });
      cb(this.restaurants1);
    }
  }
};